<template lang="pug">
    section#banner
        div.wrapper
            h2 Fael +
            h3
                span.hash #FiqueiEmCasaEVouAprenderComFAEL+
                span.cursos
                    strong + de 100 cursos gratuitos
                    | pela segurança, saúde e educação dos brasileiros.
            div.buttons
                //- button.soualuno(@click="$emit('jasoualuno')") Já sou aluno
                button.querocadastrar Inscrições Encerradas!
</template>

<script>
export default {
    name: "section-banner"
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>
